import { render, staticRenderFns } from "./shenhe.vue?vue&type=template&id=252fa722"
import script from "./shenhe.vue?vue&type=script&lang=js"
export * from "./shenhe.vue?vue&type=script&lang=js"
import style0 from "./shenhe.vue?vue&type=style&index=0&id=252fa722&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports